/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronMiniRight: {
  name: 'chevron-mini-right';
  data: string;
} = {
  name: 'chevron-mini-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.293 8.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L12.586 12l-2.293-2.293a1 1 0 0 1 0-1.414Z" fill="currentColor"/></svg>`,
};
